// Any link that does not contain the current site prefix should open in a new tab.
// This is to prevent users from accidentally navigating away from the site when clicking on external links.
export function externalLinks ($) {
	const sitePrefix = window.ff_settings.site_url.replace(/\/?$/, '/');
	const sitePrefixWithoutSlash = sitePrefix.replace(/\/$/, '');
	const links = document.querySelectorAll("a[href]");

	links.forEach(link => {
		if (!link.href.startsWith(sitePrefix) && link.href !== sitePrefixWithoutSlash) {
			link.setAttribute("target", "_blank");
			link.setAttribute("rel", "noopener noreferrer");
		}
	});
}